import React from "react";
import { apiCall } from "../Api/auth";
import Header from "../Components/Header/Header";
import Spinner from 'react-bootstrap/Spinner';
import Modal from 'react-bootstrap/Modal';
import { API_URL } from "../Api/config";

function Login() {

    const [password, setPassword] = React.useState("");
    const [email, setEmail] = React.useState("");

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [show, setShow] = React.useState(false);
    const [validated, setValidated] = React.useState(false);
    const [apicall, setApicall] = React.useState(false);

    const handleSubmit = async (event) => {
        setApicall(true);
        apiCall(API_URL + "user/login", "POST", { email: email, password: password }, event).then((res) => {
            console.log("my responce", res);
            // let message = res.data.message;
            // if (res.code === 200) {
            //     let data = res.data.data;
            //     let token = res.data.token;
            //     if (data !== null) {
            //         localStorage.setItem("user", JSON.stringify(data));
            //         localStorage.setItem("token", token);
            //         window.location.href = "/dashboard";
            //         alert(message);
            // setApicall(false);
            // handleShow();
            //     } else {
            //         alert(message);
            //     }
            // } else {
            //     alert(message);
            // }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
        });
        setValidated(true);

    }


    return (
        <>
            <Modal
                show={show} // Show the modal when `show` is true
                onHide={handleClose}
                centered
                id="success_tic"
                className='model-thank-you'
            >
                <Modal.Body>
                    <div className="logo-modal mb-4 text-center">
                        <img src={require('../assets/images/logo_text.png')} alt="logo" />
                    </div>
                    <h3 className="text-center">User login successfully </h3>

                </Modal.Body>
            </Modal>
            <div className="container mt-5 w-50 d-flex justify-content-center align-items-center bg-white p-5">
                <form onSubmit={handleSubmit}>
                    <div className="form-outline mb-4">
                        <label className="form-label" htmlFor="form2Example1">Email address</label>
                        <input required type="email" id="form2Example1" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>

                    <div className="form-outline mb-4">
                        <label className="form-label" htmlFor="form2Example2">Password</label>
                        <input required type="password" id="form2Example2" className="form-control" value={password} onChange={(e) => setPassword(e.target.value)} />
                    </div>

                    <div className="row mb-4">
                        <div className="col d-flex justify-content-center">
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="form2Example31" checked />
                                <label className="form-check-label" htmlFor="form2Example31">Remember me</label>
                            </div>
                        </div>

                    </div>

                    <button type="submit" className="btn btn-primary btn-block mb-4">Sign in</button>

                    <div className="text-center">

                        <button type="button" className="btn btn-link btn-floating mx-1">
                            <i className="fab fa-facebook-f"></i>
                        </button>

                        <button type="button" className="btn btn-link btn-floating mx-1">
                            <i className="fab fa-google"></i>
                        </button>

                        <button type="button" className="btn btn-link btn-floating mx-1">
                            <i className="fab fa-twitter"></i>
                        </button>

                        <button type="button" className="btn btn-link btn-floating mx-1">
                            <i className="fab fa-github"></i>
                        </button>
                    </div>
                </form>
            </div>

            {/* <Footer /> */}

        </>
    );
}

export default Login;